/** Accessible delivery-status chips (label + color, not color alone). */
const DELIVERY_STATUS_STYLES = {
    "Awaiting Pickup": { bg: "#dbeafe", color: "#1e40af", border: "#93c5fd" },
    "Shipped / Scheduled": { bg: "#fef3c7", color: "#92400e", border: "#fcd34d" },
    Delivered: { bg: "#d1fae5", color: "#065f46", border: "#6ee7b7" },
    "Closed + Reconciled": { bg: "#ccfbf1", color: "#0f766e", border: "#5eead4" },
    Cancelled: { bg: "#fee2e2", color: "#991b1b", border: "#fca5a5" },
};

const DEFAULT_STYLE = { bg: "#f1f5f9", color: "#475569", border: "#e2e8f0" };

export function deliveryStatusChipSx(status) {
    const s = DELIVERY_STATUS_STYLES[status] || DEFAULT_STYLE;
    return {
        height: 24,
        fontWeight: 600,
        fontSize: 12,
        borderRadius: "8px",
        backgroundColor: s.bg,
        color: s.color,
        border: `1px solid ${s.border}`,
    };
}
